import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGlyph = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4.75 3C5.7165 3 6.5 3.7835 6.5 4.75C6.5 5.7165 5.7165 6.5 4.75 6.5C3.7835 6.5 3 5.7165 3 4.75C3 3.7835 3.7835 3 4.75 3Z",
		fill: "currentcolor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 0C13.1046 1.61066e-07 14 0.89543 14 2V12C14 13.1046 13.1046 14 12 14H2C0.895431 14 1.00665e-08 13.1046 0 12V2C1.61066e-07 0.895431 0.89543 1.00665e-08 2 0H12ZM2 1.5C1.72386 1.5 1.5 1.72386 1.5 2V12C1.5 12.2761 1.72386 12.5 2 12.5H2.64355L8.91797 4.77734L8.9707 4.71875C9.10105 4.58887 9.27537 4.51065 9.46094 4.50098C9.673 4.49004 9.88013 4.56958 10.0303 4.71973L12.5 7.18945V2C12.5 1.72386 12.2761 1.5 12 1.5H2ZM4.5752 12.5H12C12.2761 12.5 12.5 12.2761 12.5 12V9.31055L9.55664 6.36719L4.5752 12.5Z",
		fill: "currentcolor"
	})]
});
export default SvgGlyph;
